import { urlFiles } from '../config';

export const getCurrentDate = () => {
  const today = new Date();
  const day = String(today.getDate()).padStart(2, '0');
  const month = String(today.getMonth() + 1).padStart(2, '0');
  const year = today.getFullYear();
  return `${day}.${month}.${year}`;
};

export const getJavaLocalDate = () => {
  const today = new Date();
  const day = String(today.getDate()).padStart(2, '0');
  const month = String(today.getMonth() + 1).padStart(2, '0');
  const year = today.getFullYear();
  return `${year}-${month}-${day}`;
};

export const getMonthForSelect = (selectedYear, selectedMonth, isForInvoices) => {
  const today = new Date();
  const currentMonth = today.getMonth() + 1;
  const currentYear = today.getFullYear();
  const currentDay = today.getDate();

  const adjustedMonth = (currentMonth - 2 + 12) % 12 || 12;

  // Lata wykraczające w przyszłość
  if (selectedYear && parseInt(selectedYear, 10) > currentYear) {
    return '1';
  }

  // Lata <= currentYear - 2 → brak limitów
  if (selectedYear && parseInt(selectedYear, 10) <= currentYear - 2) {
    return selectedMonth ? String(selectedMonth) : String(adjustedMonth);
  }

  // Poprzedni rok
  if (selectedYear && parseInt(selectedYear, 10) === currentYear - 1) {
    if (currentMonth === 1 && currentDay < 20 && !isForInvoices) {
      return '11';
    }

    if (isForInvoices) {
      const month = (selectedMonth + 12) % 12;

      if (selectedMonth === 11) return '1';
      if (selectedMonth === 12) return '2';

      return `${month + 2}`;
    }

    return '12';
  }

  // Bieżący rok
  if (isForInvoices) {
    const month = (selectedMonth + 12) % 12;

    if (selectedMonth === 11) return '1';
    if (selectedMonth === 12) return '2';

    return `${month + 2}`;
  }

  const limitDay = currentMonth === 12 ? 10 : 20;
  const resultMonth = currentDay < limitDay
    ? adjustedMonth
    : ((adjustedMonth % 12) + 1);

  return String(resultMonth);
};


export const getYearForSelect = (selectedMonth, selectedYear, isForInvoices, isForFinancialStatements) => {
  const today = new Date();
  const currentYear = today.getFullYear();
  const currentMonth = today.getMonth() + 1;
  const currentDay = today.getDate();

  if (isForInvoices) {
    return String(selectedMonth > 10 ? currentYear : (selectedYear || currentYear));
  }

  if (isForFinancialStatements) {
    if (currentMonth < 4) {
      return String(currentYear - 1);
    }
    else {
      return String(currentYear);
    }
  }
  return String(currentMonth === 1 || (currentMonth === 2 && currentDay < 20) ? currentYear - 1 : currentYear);
};

export const getCurrentMonth = () => {
  const today = new Date();
  const month = String(today.getMonth());
  return month;
}

export const getCurrentYear = () => {
  const today = new Date();
  const year = String(today.getFullYear());
  return year;
}

export const isFinancialStatementPeriod = () => {
  const month = new Date().getMonth() + 1; // 1–12
  return month >= 12 || month <= 3;
};

export const getCurrentDateForInvoice = (daysToAdd, invoiceMonth, invoiceYear) => {
  // Utwórz datę faktury, ustawiając ją na pierwszy dzień miesiąca i dodając 2 miesiące
  const invoiceDate = new Date(invoiceYear, invoiceMonth - 1, 1);
  invoiceDate.setMonth(invoiceDate.getMonth() + 2);

  // Pobierz dzisiejszą datę
  const today = new Date();

  // Sprawdź, czy miesiąc i rok dzisiejszej daty są tożsame z invoiceDate
  const baseDate = (today.getMonth() === invoiceDate.getMonth() && today.getFullYear() === invoiceDate.getFullYear())
    ? today
    : invoiceDate;

  // Dodaj dni do wybranej daty bazowej
  baseDate.setDate(baseDate.getDate() + daysToAdd);
  const day = String(baseDate.getDate()).padStart(2, '0');
  const month = String(baseDate.getMonth() + 1).padStart(2, '0');
  const year = baseDate.getFullYear();

  return `${year}-${month}-${day}`;
};

export const convertDateToJavaFormat = (dateStr) => {
  const dateParts = dateStr.split(".");
  return `${dateParts[2]}-${dateParts[1]}-${dateParts[0]}`;
};

export const calculateDaysDifference = (startDate, endDate) => {
  const start = new Date(startDate);
  const end = new Date(endDate);

  // Ustaw godziny, minuty, sekundy i milisekundy na 0
  start.setHours(0, 0, 0, 0);
  end.setHours(0, 0, 0, 0);

  const timeDifference = end - start;
  return Math.ceil(timeDifference / (1000 * 60 * 60 * 24)); // Różnica w dniach
};

export const removeLegalForm = (companyName) => {
  // Lista form prawnych (dokładne dopasowanie z dużymi literami i małymi literami)
  const legalForms = [
    "sp[.]? z[.]? o[.]? o[.]?", // Sp. z o.o.
    "spółka z ograniczoną odpowiedzialnością", // pełna nazwa
    "spółka akcyjna",           // Spółka Akcyjna
    "s[.]? a[.]?",              // S.A.
    "spółka cywilna",           // Spółka Cywilna
    "spółka jawna",             // Spółka Jawna
    "sp[.]? j[.]?",             // Sp. j.
    "spółka komandytowa",       // Spółka Komandytowa
    "sp[.]? k[.]?",             // Sp. k.
    "spółka partnerska",        // Spółka Partnerska
    "spółka komandytowo-akcyjna", // pełna nazwa
    "s[.]? c[.]?",              // S.C.
    "sp[.]? p[.]?"              // Sp. P.
  ];

  // Tworzymy elastyczne wyrażenie regularne ignorujące wielkość liter
  const legalFormsRegex = new RegExp(
    `\\s*\\b(${legalForms.join("|")})\\b\\s*$`, // Dopasowanie na końcu nazwy
    "i" // Ignorowanie wielkości liter
  );

  // Usunięcie dopasowanych form prawnych z nazwy firmy
  return companyName.replace(legalFormsRegex, "").trim();
};


export const downloadFile = async (fileMetadataId, fileTypeId, accountantName, month, year, token, companyName) => {
  try {
    const response = await fetch(`${urlFiles}/${fileMetadataId}`, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}` // Pozostaw nagłówek autoryzacji
      }
    });

    if (response.ok) {
      // Ustalanie nazwy pliku na podstawie fileTypeId
      let filename;
      if (fileTypeId === 1) {
        filename = `${accountantName}_arkusz_${month}_${year}`;
      } else if (fileTypeId === 11) {
        filename = `${accountantName}_zestawienie_${month}_${year}`;
      } else if (fileTypeId === 21) {
        filename = `${accountantName}_prace_dodatkowe_${month}_${year}`;
      }
      else if (fileTypeId === 31) {
        filename = `${accountantName}_polisa`;
      }
      else if (fileTypeId === 41) {
        filename = `${accountantName}_plik_dodatkowy`;
      }
      else if (fileTypeId === 51) {
        filename = companyName ? `${removeLegalForm(companyName)}_sprawozdanie` : `sprawozdanie`;
      }
      else if (fileTypeId === 61) {
        filename = `oswiadczenie`;
      }
      else if (fileTypeId === 71) {
        filename = `${accountantName}_faktura_korekta_${month}_${year}`;
      } else {
        filename = `plik_${fileMetadataId}`; // Domyślna nazwa pliku
      }

      // Pobieranie zawartości pliku
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);

      // Dodawanie odpowiedniego rozszerzenia na podstawie contentType
      const contentType = response.headers.get("Content-Type");
      let extension = "";
      switch (contentType) {
        case "application/pdf":
          extension = ".pdf";
          break;
        case "application/vnd.ms-excel":
          extension = ".xls";
          break;
        case "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
          extension = ".xlsx";
          break;
        case "application/zip":
          extension = ".zip";
          break;
        case "text/csv":
          extension = ".csv";
          break;
        case "image/jpeg":
          extension = ".jpg";
          break;
        case "application/msword":
          extension = ".doc";
          break;
        case "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
          extension = ".docx";
          break;
        case "text/plain":
          extension = ".txt";
          break;
        default:
          extension = ""; // Jeśli typ jest nieznany, pozostaw bez rozszerzenia
      }

      // Automatyczne pobranie pliku
      const link = document.createElement('a'); // Zadeklaruj link tylko raz
      link.href = url;
      link.download = filename + extension;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      // Zwolnienie zasobów
      window.URL.revokeObjectURL(url);
    } else {
      console.error('Error downloading file:', response.statusText);
    }
  } catch (error) {
    console.error('Error downloading file:', error);
  }
};

export const handleFileSubmit = async (file, assignmentElementId, fileTypeId, fileAssignmentId, token, queryExtra = '') => {
  if (!assignmentElementId || assignmentElementId === "null" || assignmentElementId === "undefined") {
    console.error("❌ Cannot upload file: assignmentElementId is null or missing.", { assignmentElementId, fileTypeId });
    return { success: false, message: "Brak identyfikatora elementu (assignmentElementId)." };
  }

  const formData = new FormData();
  formData.append("file", file);

  try {
    const response = await fetch(
      `${urlFiles}/upload?assignmentElementId=${assignmentElementId}&fileTypeId=${fileTypeId}&fileAssignmentId=${fileAssignmentId}${queryExtra}`,
      {
        method: 'POST',
        body: formData,
        headers: {
          'Authorization': `Bearer ${token}`
        }
      }
    );

    if (response.ok) {
      const data = await response.json();
      const message = data.message || "Plik przesłany pomyślnie.";

      // Zwracamy obiekt, żeby można było użyć fileId dalej
      return {
        success: true,
        message: message,
        fileId: data.fileId || null
      };
    } else {
      const errorText = await response.text();
      alert(`❌ Błąd przesyłania pliku: ${errorText || response.statusText}`);
      return {
        success: false,
        message: errorText || response.statusText
      };
    }
  } catch (error) {
    alert(`🚨 Wystąpił błąd podczas przesyłania pliku: ${error.message}`);
    return {
      success: false,
      message: error.message
    };
  }
};

export const deleteFile = async (fileMetadataId, token) => {
  const url = `${urlFiles}/delete?fileMetadataId=${fileMetadataId}`; // Podstawowy URL endpointu usuwania

  try {
    const response = await fetch(url, {
      method: "POST",
      headers: {
        'Authorization': `Bearer ${token}`, // Nagłówek autoryzacji (np. JWT)
      },
    });

    if (!response.ok) {
      if (response.status === 404) {
        throw new Error("Nie znaleziono pliku o podanym id.");
      }
      throw new Error(`Nie udało się usunąć pliku. Status: ${response.status}`);
    }

    const result = await response.text(); // Odczytaj odpowiedź z serwera
    console.log(result); // Wyświetl komunikat o sukcesie
    return true; // Operacja zakończona powodzeniem
  } catch (error) {
    alert(`Wystąpił błąd usuwania pliku: ${error.message}`);
    return false; // Operacja zakończona niepowodzeniem
  }
};

export const updateFileDates = async (fileMetadataId, validFrom, validTo, token) => {
  let url = `${urlFiles}/${fileMetadataId}/dates?`;
  if (validFrom) url += `validFrom=${validFrom}&`;
  if (validTo) url += `validTo=${validTo}`;
  
  try {
    const response = await fetch(url, {
      method: "PUT",
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });

    if (!response.ok) {
      throw new Error(`Nie udało się zaktualizować dat. Status: ${response.status}`);
    }

    return true;
  } catch (error) {
    alert(`Wystąpił błąd podczas aktualizacji dat: ${error.message}`);
    return false;
  }
};

export const normalizeClientDates = (data) => {
  if (!data) return;

  const normalizeValue = (val) => {
    if (typeof val === 'string') {
      if (/^\d{4}-\d{2}$/.test(val)) {
        return `${val}-01`;
      }
      if (/^\d{4}$/.test(val)) {
        return `${val}-01-01`;
      }
    }
    return val;
  };

  if (data.fakturowniaPayableFrom) data.fakturowniaPayableFrom = normalizeValue(data.fakturowniaPayableFrom);
  if (data.dateOfEntryInKRS) data.dateOfEntryInKRS = normalizeValue(data.dateOfEntryInKRS);
  if (data.firstFiscalYear) data.firstFiscalYear = normalizeValue(data.firstFiscalYear);
  if (data.paidInAdvanceTo) data.paidInAdvanceTo = normalizeValue(data.paidInAdvanceTo);

  if (data.addressEntity && data.addressEntity.discontinueDate) {
    data.addressEntity.discontinueDate = normalizeValue(data.addressEntity.discontinueDate);
  }

  if (Array.isArray(data.cooperationHistoryDTOs)) {
    data.cooperationHistoryDTOs.forEach(item => {
      if (item.cooperationStartDate) item.cooperationStartDate = normalizeValue(item.cooperationStartDate);
      if (item.cooperationEndDate) item.cooperationEndDate = normalizeValue(item.cooperationEndDate);
      if (item.suspensionStartDate) item.suspensionStartDate = normalizeValue(item.suspensionStartDate);
      if (item.suspensionEndDate) item.suspensionEndDate = normalizeValue(item.suspensionEndDate);
    });
  }

  if (Array.isArray(data.clientTariffDTOs)) {
    data.clientTariffDTOs.forEach(item => {
      if (item.startDate) item.startDate = normalizeValue(item.startDate);
      if (item.endDate) item.endDate = normalizeValue(item.endDate);
    });
  }

  if (Array.isArray(data.clientPackageDTOs)) {
    data.clientPackageDTOs.forEach(item => {
      if (item.startDate) item.startDate = normalizeValue(item.startDate);
      if (item.endDate) item.endDate = normalizeValue(item.endDate);
    });
  }

  if (Array.isArray(data.accountantDTOs)) {
    data.accountantDTOs.forEach(item => {
      if (item.startDate) item.startDate = normalizeValue(item.startDate);
      if (item.endDate) item.endDate = normalizeValue(item.endDate);
    });
  }
};

export const normalizeAccountantDates = (data) => {
  if (!data) return;

  const normalizeValue = (val) => {
    if (typeof val === 'string') {
      if (/^\d{4}-\d{2}$/.test(val)) {
        return `${val}-01`;
      }
      if (/^\d{4}$/.test(val)) {
        return `${val}-01-01`;
      }
    }
    return val;
  };

  if (data.insuranceUpTo) data.insuranceUpTo = normalizeValue(data.insuranceUpTo);

  if (Array.isArray(data.cooperationHistoryDTOs)) {
    data.cooperationHistoryDTOs.forEach(item => {
      if (item.cooperationStartDate) item.cooperationStartDate = normalizeValue(item.cooperationStartDate);
      if (item.cooperationEndDate) item.cooperationEndDate = normalizeValue(item.cooperationEndDate);
      if (item.suspensionStartDate) item.suspensionStartDate = normalizeValue(item.suspensionStartDate);
      if (item.suspensionEndDate) item.suspensionEndDate = normalizeValue(item.suspensionEndDate);
    });
  }

  if (Array.isArray(data.accountantTariffDTOs)) {
    data.accountantTariffDTOs.forEach(item => {
      if (item.startDate) item.startDate = normalizeValue(item.startDate);
      if (item.endDate) item.endDate = normalizeValue(item.endDate);
    });
  }

  if (Array.isArray(data.accountantSupervisorDTOs)) {
    data.accountantSupervisorDTOs.forEach(item => {
      if (item.startDate) item.startDate = normalizeValue(item.startDate);
      if (item.endDate) item.endDate = normalizeValue(item.endDate);
    });
  }
};